<template functional>
    <div class="tile-content tile-content-secondary">Stop the customer's active subscriptions not only cancels renewals, but also deactivates the subscription(s) immediately (sets the end time to when the rule action runs).</div>
</template>

<script>
    export default {
        name: 'stop-subscriptions',
    };
</script>
